var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSignup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 23C5.92487 23 1 18.0751 1 12 1 5.92487 5.92487 1 12 1 18.0751 1 23 5.92487 23 12 23 18.0751 18.0751 23 12 23zM19.3995 17.1246C20.4086 15.6703 21 13.9042 21 12 21 7.02944 16.9706 3 12 3 7.02944 3 3 7.02944 3 12 3 13.9042 3.59138 15.6703 4.6005 17.1246 5.72595 15.6381 8.3706 15 12 15 15.6294 15 18.274 15.6381 19.3995 17.1246zM17.9647 18.7398C17.672 17.6874 15.5694 17 12 17 8.43062 17 6.328 17.6874 6.03532 18.7398 7.6233 20.1462 9.71194 21 12 21 14.2881 21 16.3767 20.1462 17.9647 18.7398zM12 15C9.76086 15 8 13.4274 8 10 8 7.75576 9.5791 6 12 6 14.4142 6 16 7.92158 16 10.2 16 13.4796 14.2181 15 12 15zm-2-5C10 12.2693 10.8182 13 12 13 13.1777 13 14 12.2984 14 10.2 14 8.95042 13.2157 8 12 8 10.7337 8 10 8.81582 10 10z",
    fill: "#006aff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignup);
export default __webpack_public_path__ + "static/media/signup.de4ae476.svg";
export { ForwardRef as ReactComponent };